/**
 * @fileoverview Company logo upload field for the Corporate Identity section.
 */

import FileUploadArea from "../../../modals/ProposalCreateModal/FileUploadArea";
import { isFieldReadOnlyForProfile } from "../../../utils/common";
import styles from "./CorporateIdentity.module.css";
import { CURSOR_NOT_ALLOWED } from "./corporateIdentityConstants";

export default function CorporateIdentityLogoUpload({
  selectedProfile,
  section,
}) {
  const {
    t,
    isMobile,
    logoFile,
    isUploading,
    isDragging,
    error,
    handleFileChange,
    handleDragOver,
    handleDragLeave,
    handleDrop,
    handleFileClick,
  } = section;

  return (
    <div
      className={`${styles.inputRow} ${styles.twoInputsRow} ${styles.logoAndCompanyActivityRow}`}
    >
      <div className={`${styles.inputGroup} ${styles.twoLabelsGroup}`}>
        <label
          className={`${styles.inputLabel} ${
            isMobile ? styles.mobileLogoLabel : ""
          }`}
        >
          {t("components.corporateIdentity.logoLabel")}
        </label>
        <div
          className={styles.fileUploadContainer}
          style={
            isFieldReadOnlyForProfile("logo", selectedProfile)
              ? { cursor: CURSOR_NOT_ALLOWED, opacity: 0.7 }
              : {}
          }
        >
          <FileUploadArea
            file={logoFile}
            isUploading={isUploading}
            isDragging={isDragging}
            error={error}
            onFileChange={
              isFieldReadOnlyForProfile("logo", selectedProfile)
                ? () => {}
                : handleFileChange
            }
            onDragOver={
              isFieldReadOnlyForProfile("logo", selectedProfile)
                ? () => {}
                : handleDragOver
            }
            onDragLeave={
              isFieldReadOnlyForProfile("logo", selectedProfile)
                ? () => {}
                : handleDragLeave
            }
            onDrop={
              isFieldReadOnlyForProfile("logo", selectedProfile)
                ? () => {}
                : handleDrop
            }
            onClick={
              isFieldReadOnlyForProfile("logo", selectedProfile)
                ? () => {}
                : handleFileClick
            }
            reduceHeightForMobile={isMobile}
          />
          {!isFieldReadOnlyForProfile("logo", selectedProfile) && (
            <input
              id="logoFileInput"
              type="file"
              onChange={handleFileChange}
              className={styles.fileInput}
              style={{ display: "none" }}
            />
          )}
        </div>
        <p className={styles.notVisibleFieldMessage}>
          *{t("components.corporateIdentity.mandatoryFieldMessage")}
        </p>
      </div>
    </div>
  );
}
